import { useState } from "react";
import { useShare } from "@/hooks/useShare";

interface ShareMenuProps {
  path: string;
  title: string;
}

export default function ShareMenu({ path, title }: ShareMenuProps) {
  const { copyLink, shareTo, toast } = useShare();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-20 mt-2 w-48 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-1">
            <button
              type="button"
              onClick={() => {
                copyLink(path);
                setOpen(false);
              }}
              className="flex w-full cursor-pointer items-center gap-3 rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-link text-base text-primary-600" />
              复制链接
            </button>
            <button
              type="button"
              onClick={() => {
                shareTo("weibo", path, title);
                setOpen(false);
              }}
              className="flex w-full cursor-pointer items-center gap-3 rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-weibo-fill text-base text-accent-600" />
              分享到微博
            </button>
            <button
              type="button"
              onClick={() => {
                shareTo("x", path, title);
                setOpen(false);
              }}
              className="flex w-full cursor-pointer items-center gap-3 rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-twitter-x-fill text-base text-foreground-900" />
              分享到 X
            </button>
            <button
              type="button"
              onClick={() => {
                shareTo("facebook", path, title);
                setOpen(false);
              }}
              className="flex w-full cursor-pointer items-center gap-3 rounded-md px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-facebook-circle-fill text-base text-primary-500" />
              分享到 Facebook
            </button>
          </div>
        </>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 rounded-md bg-foreground-950 px-5 py-3 text-sm text-background-50">
          {toast}
        </div>
      )}
    </div>
  );
}